// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Services/DataEngg/section-3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/Services/CloudEngg/section3-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/Services/InteAuto/inte-auto-sec5-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#InteAuto-prt1,
#InteAuto-prt2,
#InteAuto-prt3,
#InteAuto-prt4,
#InteAuto-prt5,
#InteAuto-prt6 {
    margin: 0% 10% 100px 10%;
}

#InteAuto-prt1>p {
    font-size: 22px;
    margin-top: 250px;
    margin-bottom: -50px;
    font-weight: 600;
}

#InteAuto-prt1>div>h1 {
    font-size: 80px;
    font-weight: 100;
    width: 90%;
    /* margin-top: -100px; */
}

#InteAuto-prt1>div {
    align-items: center;
    display: flex;
}

#InteAuto-prt1>div>h1>span {
    font-weight: 800;
}

#InteAuto-prt1>div>img {
    width: 500px;
}

#InteAuto-prt2 {
    margin-top: -500px;
    display: flex;
    align-items: center;
}


.InteAuto-section-3-left>p>span:nth-child(1) {
    color: #0096FE;
}

.InteAuto-section-3-left>p>span:nth-child(2) {
    font-weight: 800;
}

.InteAuto-section-3-left {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    & p:nth-child(1) {
        font-size: 48px;
        margin: 0;
    }

    & p:nth-child(2) {
        font-size: 48px;
        font-weight: bold;
        margin: 0;
        margin-bottom: 2rem;
    }

    & p:nth-child(3),
    & p:nth-child(4) {
        font-size: var(--font-size4);
        margin-bottom: 2rem;
    }
}

.InteAuto-section-3-right {
    display: flex;
    justify-content: space-around;
    width: 50%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center;
    background-repeat: no-repeat;
    background-position: center 120px;
    margin: auto;
    padding: 2%;

    & p:nth-child(1) {

        font-size: var(--font-size6);
        font-weight: bold;
    }

    & p:nth-child(2) {
        font-size: 1.2rem
    }
}

.InteAuto-section-3-right-1,
.InteAuto-section-3-right-2 {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 60px;
    padding: 0.5rem;


    & div {
        border: 2px solid green;
        padding: 1rem;
        background: rgba(255, 255, 255, 0.7);
        -webkit-backdrop-filter: blur(10px);
                backdrop-filter: blur(10px);
        border-radius: 1rem;
        border: 5px solid lightgray;
    }
}


#circle-inteAuto-compo {
    text-align: center;
}

#circle-inteAuto-compo>h1 {
    font-weight: 200;
    color: #292962;
}

#circle-inteAuto-compo>h1>span {
    font-weight: 800;
}

#InteAuto-prt3 {
    display: grid;
    gap: 10px;
    grid-template-columns: repeat(3, 1fr);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-position: center;
    background-repeat: no-repeat;
    background-size: 900px;
    padding: 100px 0px;
}

.sec3-cont>img {
    width: 40px;
}

.sec3-cont {
    background-color: #ffffff;
    padding: 20px;
    border-radius: 20px;
    /* box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px; */
    /* background-position: top 500px; */
}

#InteAuto-prt3>:nth-child(2) {
    /* border: 1px solid black; */
    margin-left: 50px;
}

.sec3-cont>p {
    width: 70%;
}

#sec3-prt1>p {
    font-size: 20px;
}

#InteAuto-prt4 {
    margin-top: 0px;
}

#InteAuto-prt4>.sec4-prt1 {
    text-align: center;
}

.sec4-prt1>h1>span {
    font-weight: 1000;
}

.sec4-prt1>h1 {
    font-weight: 200;
}

.sec4-prt1>p {
    font-size: 20px;
}

.sec4-prt2 {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    justify-content: space-around;
}

.sec4-prt2>div>img {
    width: 75px;
}

.sec4-prt2>div>p {
    width: 70%;
}

.sec4-prt2>div {
    background-color: #F3F7FF;
    padding: 20px;
    border-radius: 20px;
}


#InteAuto-prt5 {
    margin-top: 200px;
    margin-bottom: 100px;
}

#InteAuto-prt5>h1 {
    color: #292962;
    width: 40%;
    font-weight: 300;
}

#InteAuto-prt5>h1>span {
    font-weight: 600;
}

#InteAuto-sec5-cont {
    display: flex;
}

#inteauto-sec5-cont-prt1 {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    width: 70%;
    /* border: 1px solid green; */
}

#inteauto-sec5-cont-prt2 {
    background:
        linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1)),
        url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}


#inteauto-sec5-cont-prt1>div>img {
    width: 50px;
}

#inteauto-sec5-cont-prt1>:nth-child(1) {
    padding: 15px;
    border-bottom: 1px solid #4FC1AD;
    border-right: 1px solid #4FC1AD;
    border-radius: 40px;
}

#inteauto-sec5-cont-prt1>:nth-child(2) {
    padding: 15px;
    border-bottom: 1px solid #4FC1AD;
    border-left: 1px solid #4FC1AD;
    border-radius: 40px;
}

#inteauto-sec5-cont-prt1>:nth-child(3) {
    padding: 15px;
    border-top: 1px solid #4FC1AD;
    border-right: 1px solid #4FC1AD;
    border-radius: 40px;
}

#inteauto-sec5-cont-prt1>:nth-child(4) {
    padding: 15px;
    border-top: 1px solid #4FC1AD;
    border-left: 1px solid #4FC1AD;
    border-radius: 40px;
}

#inteauto-sec5-cont-prt2 {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: 60%;
    padding-bottom: 50px;
    padding-left: 50px;
    border-radius: 30px;
}

#inteauto-sec5-cont-prt2>h1 {
    color: #ffffff;
    width: 80%;
    font-size: 55px;
    font-weight: 200;
}

#inteauto-sec5-cont-prt2>h1>span {
    font-weight: 600;
}

#InteAuto-prt6>h1 {
    font-weight: 200;
    font-size: 48px;
    align-items: center;
    text-align: center;
}

#InteAuto-prt6 {
    margin-top: 200px;
}

#InteAuto-prt6>h1>span>img {
    width: 62px;
    border-radius: 100%;
    vertical-align: middle;
    background-color: #0B63E5;
}

#InteAuto-prt6>h1>span {
    font-weight: 800;
}

@media (max-width: 1450px) {
    #InteAuto-prt1>div>img {
        width: 500px;
        height: 400px;
    }

    #InteAuto-prt4 {
        margin-top: 0px;
    }
}

@media (max-width: 1200px) {
    #InteAuto-prt1>div>img {
        width: 300px;
        height: 200px;
    }

    #InteAuto-prt1>div>h1 {
        font-size: 40px;
    }

    #InteAuto-prt2 {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        margin-top: 400px;
    }

    .InteAuto-section-3-left,
    .InteAuto-section-3-right {
        width: 90%;
    }

    .InteAuto-section-3-left,
    .InteAuto-section-3-left & p:nth-child(2) {

        & p:nth-child(1) {
            font-size: 38px;
            width: 100%s;
        }
    }

    #InteAuto-sec5-cont {
        display: flex;
        flex-direction: column-reverse;
    }

    #inteauto-sec5-cont-prt1 {
        width: 95%;
    }

    #inteauto-sec5-cont-prt2 {
        width: 90%;
    }

    #InteAuto-prt5>h1 {
        width: 80%;
    }
}

@media (max-width : 901px) {
    #InteAuto-prt3 {
        grid-template-columns: repeat(1, 1fr);
        background-image: none;
        background-size: 0px;
        padding: 0px;
        margin-left: 0px;
        
    }
    #InteAuto-prt1>p {
        font-size: 22px;
        margin-top: 0px;
        margin-bottom: 0px;
        font-weight: 600;
    }

    #sec3-prt1>h1,
    #sec3-prt1>p {
        margin-left: 10%;
    }

    .sec3-cont>p {
        width: 40%;
    }

    .sec4-prt2 {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 600px) {
    #InteAuto-prt1>div {
        align-items: center;
        display: flex;
        flex-direction: column;
    }
    #InteAuto-prt1>p {
        font-size: 22px;
        margin-top: 0px;
        margin-bottom: 0px;
        font-weight: 600;
    }

    #InteAuto-prt2 {
        margin-top: 50px;
    }

    .InteAuto-section-3-left,
    .InteAuto-section-3-left & p:nth-child(2) {

        & p:nth-child(1) {
            font-size: 28px;
            width: 100%;
        }

        & p:nth-child(3) {
            font-size: 17px;
        }
    }

    .InteAuto-section-3-right {
        margin-left: -10px;
        width: 110%;

        & p:nth-child(1) {
            font-size: 22px;
            font-weight: bold;
        }

        & p:nth-child(2) {
            font-size: 14px
        }
    }

    .InteAuto-section-3-right-1,
    .InteAuto-section-3-right-2 {
        & div {
            border: 2px solid green;
            padding: 1rem;
            background: rgba(255, 255, 255, 0.7);
            -webkit-backdrop-filter: blur(10px);
                    backdrop-filter: blur(10px);
            border-radius: 1rem;
            border: 5px solid lightgray;
        }
    }



    #InteAuto-prt3 {
        margin-left: -50px;
        margin-right: 20%;
        margin-top: -50px;
    }

    #sec3-prt1>h1,
    #sec3-prt1>p {
        margin-left: 20%;
    }

    .sec4-prt2 {
        grid-template-columns: repeat(1, 1fr);
    }

    #InteAuto-prt5 {
        margin-top: -50px;
    }

    #InteAuto-prt5>h1 {
        font-size: 25px;
        width: 100%;
        text-align: center;
    }

    #inteauto-sec5-cont-prt1 {
        width: 95%;
        grid-template-columns: repeat(1, 1fr);
    }

    #inteauto-sec5-cont-prt1 {
        width: 100%;
    }

    #inteauto-sec5-cont-prt2>h1 {
        color: #ffffff;
        width: 90%;
        font-size: 28px;
        font-weight: 200;
    }

    #inteauto-sec5-cont-prt2 {
        width: 85%;
    }

    #InteAuto-prt6 {
        margin-top: -20px;
        margin-bottom: 0px;
    }

    #InteAuto-prt6>h1 {
        font-weight: 200;
        font-size: 23px;
        align-items: center;
    }

    #InteAuto-prt6>h1>span>img {
        width: 42px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Services/InteAuto.css"],"names":[],"mappings":"AAAA;;;;;;IAMI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;;AAGA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;;IAEvB;QACI,eAAe;QACf,SAAS;IACb;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,SAAS;QACT,mBAAmB;IACvB;;IAEA;;QAEI,4BAA4B;QAC5B,mBAAmB;IACvB;AACJ;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,UAAU;IACV,yDAAqE;IACrE,2BAA2B;IAC3B,4BAA4B;IAC5B,iCAAiC;IACjC,YAAY;IACZ,WAAW;;IAEX;;QAEI,4BAA4B;QAC5B,iBAAiB;IACrB;;IAEA;QACI;IACJ;AACJ;;AAEA;;IAEI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,eAAe;;;IAGf;QACI,uBAAuB;QACvB,aAAa;QACb,oCAAoC;QACpC,mCAA2B;gBAA3B,2BAA2B;QAC3B,mBAAmB;QACnB,2BAA2B;IAC/B;AACJ;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,qCAAqC;IACrC,yDAAwE;IACxE,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,2DAA2D;IAC3D,oCAAoC;AACxC;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;;;AAGA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI;;+CAE+D;IAC/D,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;AAChC;;;AAGA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,UAAU;IACV,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,qCAAqC;QACrC,iBAAiB;IACrB;;IAEA;;QAEI,UAAU;IACd;;IAEA;;;QAGI;YACI,eAAe;YACf,YAAY;QAChB;IACJ;;IAEA;QACI,aAAa;QACb,8BAA8B;IAClC;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,qCAAqC;QACrC,sBAAsB;QACtB,oBAAoB;QACpB,YAAY;QACZ,gBAAgB;;IAEpB;IACA;QACI,eAAe;QACf,eAAe;QACf,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,aAAa;QACb,sBAAsB;IAC1B;IACA;QACI,eAAe;QACf,eAAe;QACf,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;;QAGI;YACI,eAAe;YACf,WAAW;QACf;;QAEA;YACI,eAAe;QACnB;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;;QAEX;YACI,eAAe;YACf,iBAAiB;QACrB;;QAEA;YACI;QACJ;IACJ;;IAEA;;QAEI;YACI,uBAAuB;YACvB,aAAa;YACb,oCAAoC;YACpC,mCAA2B;oBAA3B,2BAA2B;YAC3B,mBAAmB;YACnB,2BAA2B;QAC/B;IACJ;;;;IAIA;QACI,kBAAkB;QAClB,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,UAAU;QACV,qCAAqC;IACzC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,cAAc;QACd,UAAU;QACV,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":["#InteAuto-prt1,\r\n#InteAuto-prt2,\r\n#InteAuto-prt3,\r\n#InteAuto-prt4,\r\n#InteAuto-prt5,\r\n#InteAuto-prt6 {\r\n    margin: 0% 10% 100px 10%;\r\n}\r\n\r\n#InteAuto-prt1>p {\r\n    font-size: 22px;\r\n    margin-top: 250px;\r\n    margin-bottom: -50px;\r\n    font-weight: 600;\r\n}\r\n\r\n#InteAuto-prt1>div>h1 {\r\n    font-size: 80px;\r\n    font-weight: 100;\r\n    width: 90%;\r\n    /* margin-top: -100px; */\r\n}\r\n\r\n#InteAuto-prt1>div {\r\n    align-items: center;\r\n    display: flex;\r\n}\r\n\r\n#InteAuto-prt1>div>h1>span {\r\n    font-weight: 800;\r\n}\r\n\r\n#InteAuto-prt1>div>img {\r\n    width: 500px;\r\n}\r\n\r\n#InteAuto-prt2 {\r\n    margin-top: -500px;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n\r\n.InteAuto-section-3-left>p>span:nth-child(1) {\r\n    color: #0096FE;\r\n}\r\n\r\n.InteAuto-section-3-left>p>span:nth-child(2) {\r\n    font-weight: 800;\r\n}\r\n\r\n.InteAuto-section-3-left {\r\n    width: 50%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n\r\n    & p:nth-child(1) {\r\n        font-size: 48px;\r\n        margin: 0;\r\n    }\r\n\r\n    & p:nth-child(2) {\r\n        font-size: 48px;\r\n        font-weight: bold;\r\n        margin: 0;\r\n        margin-bottom: 2rem;\r\n    }\r\n\r\n    & p:nth-child(3),\r\n    & p:nth-child(4) {\r\n        font-size: var(--font-size4);\r\n        margin-bottom: 2rem;\r\n    }\r\n}\r\n\r\n.InteAuto-section-3-right {\r\n    display: flex;\r\n    justify-content: space-around;\r\n    width: 50%;\r\n    background-image: url('../../assets/Services/DataEngg/section-3.png');\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    background-position: center 120px;\r\n    margin: auto;\r\n    padding: 2%;\r\n\r\n    & p:nth-child(1) {\r\n\r\n        font-size: var(--font-size6);\r\n        font-weight: bold;\r\n    }\r\n\r\n    & p:nth-child(2) {\r\n        font-size: 1.2rem\r\n    }\r\n}\r\n\r\n.InteAuto-section-3-right-1,\r\n.InteAuto-section-3-right-2 {\r\n    width: 50%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    gap: 60px;\r\n    padding: 0.5rem;\r\n\r\n\r\n    & div {\r\n        border: 2px solid green;\r\n        padding: 1rem;\r\n        background: rgba(255, 255, 255, 0.7);\r\n        backdrop-filter: blur(10px);\r\n        border-radius: 1rem;\r\n        border: 5px solid lightgray;\r\n    }\r\n}\r\n\r\n\r\n#circle-inteAuto-compo {\r\n    text-align: center;\r\n}\r\n\r\n#circle-inteAuto-compo>h1 {\r\n    font-weight: 200;\r\n    color: #292962;\r\n}\r\n\r\n#circle-inteAuto-compo>h1>span {\r\n    font-weight: 800;\r\n}\r\n\r\n#InteAuto-prt3 {\r\n    display: grid;\r\n    gap: 10px;\r\n    grid-template-columns: repeat(3, 1fr);\r\n    background-image: url(\"../../assets/Services/CloudEngg/section3-bg.png\");\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    background-size: 900px;\r\n    padding: 100px 0px;\r\n}\r\n\r\n.sec3-cont>img {\r\n    width: 40px;\r\n}\r\n\r\n.sec3-cont {\r\n    background-color: #ffffff;\r\n    padding: 20px;\r\n    border-radius: 20px;\r\n    /* box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px; */\r\n    /* background-position: top 500px; */\r\n}\r\n\r\n#InteAuto-prt3>:nth-child(2) {\r\n    /* border: 1px solid black; */\r\n    margin-left: 50px;\r\n}\r\n\r\n.sec3-cont>p {\r\n    width: 70%;\r\n}\r\n\r\n#sec3-prt1>p {\r\n    font-size: 20px;\r\n}\r\n\r\n#InteAuto-prt4 {\r\n    margin-top: 0px;\r\n}\r\n\r\n#InteAuto-prt4>.sec4-prt1 {\r\n    text-align: center;\r\n}\r\n\r\n.sec4-prt1>h1>span {\r\n    font-weight: 1000;\r\n}\r\n\r\n.sec4-prt1>h1 {\r\n    font-weight: 200;\r\n}\r\n\r\n.sec4-prt1>p {\r\n    font-size: 20px;\r\n}\r\n\r\n.sec4-prt2 {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, 1fr);\r\n    gap: 20px;\r\n    justify-content: space-around;\r\n}\r\n\r\n.sec4-prt2>div>img {\r\n    width: 75px;\r\n}\r\n\r\n.sec4-prt2>div>p {\r\n    width: 70%;\r\n}\r\n\r\n.sec4-prt2>div {\r\n    background-color: #F3F7FF;\r\n    padding: 20px;\r\n    border-radius: 20px;\r\n}\r\n\r\n\r\n#InteAuto-prt5 {\r\n    margin-top: 200px;\r\n    margin-bottom: 100px;\r\n}\r\n\r\n#InteAuto-prt5>h1 {\r\n    color: #292962;\r\n    width: 40%;\r\n    font-weight: 300;\r\n}\r\n\r\n#InteAuto-prt5>h1>span {\r\n    font-weight: 600;\r\n}\r\n\r\n#InteAuto-sec5-cont {\r\n    display: flex;\r\n}\r\n\r\n#inteauto-sec5-cont-prt1 {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 1fr);\r\n    width: 70%;\r\n    /* border: 1px solid green; */\r\n}\r\n\r\n#inteauto-sec5-cont-prt2 {\r\n    background:\r\n        linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1)),\r\n        url(\"../../assets/Services/InteAuto/inte-auto-sec5-bg.png\");\r\n    background-position: center;\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n}\r\n\r\n\r\n#inteauto-sec5-cont-prt1>div>img {\r\n    width: 50px;\r\n}\r\n\r\n#inteauto-sec5-cont-prt1>:nth-child(1) {\r\n    padding: 15px;\r\n    border-bottom: 1px solid #4FC1AD;\r\n    border-right: 1px solid #4FC1AD;\r\n    border-radius: 40px;\r\n}\r\n\r\n#inteauto-sec5-cont-prt1>:nth-child(2) {\r\n    padding: 15px;\r\n    border-bottom: 1px solid #4FC1AD;\r\n    border-left: 1px solid #4FC1AD;\r\n    border-radius: 40px;\r\n}\r\n\r\n#inteauto-sec5-cont-prt1>:nth-child(3) {\r\n    padding: 15px;\r\n    border-top: 1px solid #4FC1AD;\r\n    border-right: 1px solid #4FC1AD;\r\n    border-radius: 40px;\r\n}\r\n\r\n#inteauto-sec5-cont-prt1>:nth-child(4) {\r\n    padding: 15px;\r\n    border-top: 1px solid #4FC1AD;\r\n    border-left: 1px solid #4FC1AD;\r\n    border-radius: 40px;\r\n}\r\n\r\n#inteauto-sec5-cont-prt2 {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-end;\r\n    width: 60%;\r\n    padding-bottom: 50px;\r\n    padding-left: 50px;\r\n    border-radius: 30px;\r\n}\r\n\r\n#inteauto-sec5-cont-prt2>h1 {\r\n    color: #ffffff;\r\n    width: 80%;\r\n    font-size: 55px;\r\n    font-weight: 200;\r\n}\r\n\r\n#inteauto-sec5-cont-prt2>h1>span {\r\n    font-weight: 600;\r\n}\r\n\r\n#InteAuto-prt6>h1 {\r\n    font-weight: 200;\r\n    font-size: 48px;\r\n    align-items: center;\r\n    text-align: center;\r\n}\r\n\r\n#InteAuto-prt6 {\r\n    margin-top: 200px;\r\n}\r\n\r\n#InteAuto-prt6>h1>span>img {\r\n    width: 62px;\r\n    border-radius: 100%;\r\n    vertical-align: middle;\r\n    background-color: #0B63E5;\r\n}\r\n\r\n#InteAuto-prt6>h1>span {\r\n    font-weight: 800;\r\n}\r\n\r\n@media (max-width: 1450px) {\r\n    #InteAuto-prt1>div>img {\r\n        width: 500px;\r\n        height: 400px;\r\n    }\r\n\r\n    #InteAuto-prt4 {\r\n        margin-top: 0px;\r\n    }\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n    #InteAuto-prt1>div>img {\r\n        width: 300px;\r\n        height: 200px;\r\n    }\r\n\r\n    #InteAuto-prt1>div>h1 {\r\n        font-size: 40px;\r\n    }\r\n\r\n    #InteAuto-prt2 {\r\n        display: grid;\r\n        grid-template-columns: repeat(1, 1fr);\r\n        margin-top: 400px;\r\n    }\r\n\r\n    .InteAuto-section-3-left,\r\n    .InteAuto-section-3-right {\r\n        width: 90%;\r\n    }\r\n\r\n    .InteAuto-section-3-left,\r\n    .InteAuto-section-3-left & p:nth-child(2) {\r\n\r\n        & p:nth-child(1) {\r\n            font-size: 38px;\r\n            width: 100%s;\r\n        }\r\n    }\r\n\r\n    #InteAuto-sec5-cont {\r\n        display: flex;\r\n        flex-direction: column-reverse;\r\n    }\r\n\r\n    #inteauto-sec5-cont-prt1 {\r\n        width: 95%;\r\n    }\r\n\r\n    #inteauto-sec5-cont-prt2 {\r\n        width: 90%;\r\n    }\r\n\r\n    #InteAuto-prt5>h1 {\r\n        width: 80%;\r\n    }\r\n}\r\n\r\n@media (max-width : 901px) {\r\n    #InteAuto-prt3 {\r\n        grid-template-columns: repeat(1, 1fr);\r\n        background-image: none;\r\n        background-size: 0px;\r\n        padding: 0px;\r\n        margin-left: 0px;\r\n        \r\n    }\r\n    #InteAuto-prt1>p {\r\n        font-size: 22px;\r\n        margin-top: 0px;\r\n        margin-bottom: 0px;\r\n        font-weight: 600;\r\n    }\r\n\r\n    #sec3-prt1>h1,\r\n    #sec3-prt1>p {\r\n        margin-left: 10%;\r\n    }\r\n\r\n    .sec3-cont>p {\r\n        width: 40%;\r\n    }\r\n\r\n    .sec4-prt2 {\r\n        grid-template-columns: repeat(2, 1fr);\r\n    }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n    #InteAuto-prt1>div {\r\n        align-items: center;\r\n        display: flex;\r\n        flex-direction: column;\r\n    }\r\n    #InteAuto-prt1>p {\r\n        font-size: 22px;\r\n        margin-top: 0px;\r\n        margin-bottom: 0px;\r\n        font-weight: 600;\r\n    }\r\n\r\n    #InteAuto-prt2 {\r\n        margin-top: 50px;\r\n    }\r\n\r\n    .InteAuto-section-3-left,\r\n    .InteAuto-section-3-left & p:nth-child(2) {\r\n\r\n        & p:nth-child(1) {\r\n            font-size: 28px;\r\n            width: 100%;\r\n        }\r\n\r\n        & p:nth-child(3) {\r\n            font-size: 17px;\r\n        }\r\n    }\r\n\r\n    .InteAuto-section-3-right {\r\n        margin-left: -10px;\r\n        width: 110%;\r\n\r\n        & p:nth-child(1) {\r\n            font-size: 22px;\r\n            font-weight: bold;\r\n        }\r\n\r\n        & p:nth-child(2) {\r\n            font-size: 14px\r\n        }\r\n    }\r\n\r\n    .InteAuto-section-3-right-1,\r\n    .InteAuto-section-3-right-2 {\r\n        & div {\r\n            border: 2px solid green;\r\n            padding: 1rem;\r\n            background: rgba(255, 255, 255, 0.7);\r\n            backdrop-filter: blur(10px);\r\n            border-radius: 1rem;\r\n            border: 5px solid lightgray;\r\n        }\r\n    }\r\n\r\n\r\n\r\n    #InteAuto-prt3 {\r\n        margin-left: -50px;\r\n        margin-right: 20%;\r\n        margin-top: -50px;\r\n    }\r\n\r\n    #sec3-prt1>h1,\r\n    #sec3-prt1>p {\r\n        margin-left: 20%;\r\n    }\r\n\r\n    .sec4-prt2 {\r\n        grid-template-columns: repeat(1, 1fr);\r\n    }\r\n\r\n    #InteAuto-prt5 {\r\n        margin-top: -50px;\r\n    }\r\n\r\n    #InteAuto-prt5>h1 {\r\n        font-size: 25px;\r\n        width: 100%;\r\n        text-align: center;\r\n    }\r\n\r\n    #inteauto-sec5-cont-prt1 {\r\n        width: 95%;\r\n        grid-template-columns: repeat(1, 1fr);\r\n    }\r\n\r\n    #inteauto-sec5-cont-prt1 {\r\n        width: 100%;\r\n    }\r\n\r\n    #inteauto-sec5-cont-prt2>h1 {\r\n        color: #ffffff;\r\n        width: 90%;\r\n        font-size: 28px;\r\n        font-weight: 200;\r\n    }\r\n\r\n    #inteauto-sec5-cont-prt2 {\r\n        width: 85%;\r\n    }\r\n\r\n    #InteAuto-prt6 {\r\n        margin-top: -20px;\r\n        margin-bottom: 0px;\r\n    }\r\n\r\n    #InteAuto-prt6>h1 {\r\n        font-weight: 200;\r\n        font-size: 23px;\r\n        align-items: center;\r\n    }\r\n\r\n    #InteAuto-prt6>h1>span>img {\r\n        width: 42px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
